import React, { useState, useEffect } from 'react';
import Icon from 'components/AppIcon';
import BreadcrumbNavigation from 'components/ui/BreadcrumbNavigation';
import { useSelector } from 'react-redux';

//Report Types
import RevenueReport from './revenue-report';

const Reporting = () =>{
    const selectedBusiness = useSelector((state) => state?.business.selectedBusiness);
    return (
        <div className="p-4 lg:p-6"> 
            <div className="mb-6">
                <BreadcrumbNavigation />
                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mt-4">
                    <div>
                        <h1 className="text-2xl lg:text-3xl font-bold text-foreground flex items-center">
                        <Icon name="Landmark" size={32} className="mr-3 text-primary" />
                        Reporting
                        </h1>
                        <p className="text-muted-foreground mt-1">
                        Generate and view various reports related to your business operations.
                        </p>
                    </div>
                </div>

                <RevenueReport businessId={selectedBusiness?.businessId} />
            </div>
        </div>
    )
}

export default Reporting;   